import React, {useEffect, useState} from 'react';
import {useLocation, useHistory} from 'react-router-dom';

import i18n from 'configs/i18n';
import LanguageHelper from 'helpers/Language';

const languages = LanguageHelper.getLanguages();


function Languages() {
	const location = useLocation();
	const history = useHistory();

	const [display, setDisplay] = useState(false);
	const [language, setLanguage] = useState(LanguageHelper.getUrlLanguage());
	const [prevLanguage, setPrevLanguage] = useState(LanguageHelper.getUrlLanguage());

	const toogle = () => {
		setDisplay(!display);
	}

	const changeLanguage = (lng) => {
		setLanguage(lng);
	}

	useEffect(() => {
		i18n.changeLanguage(language);
		if (location.pathname.indexOf(prevLanguage) !== -1) {
			history.push(location.pathname.replace(prevLanguage, language));
			setPrevLanguage(language);
		}
	}, [language])

	let currentLanguage = false;
	languages.forEach((lang) => {
		if (lang.code === language) {
			currentLanguage = lang;
		}
	});

	return (
		<div
			className="language-switch-container"
			onMouseEnter={toogle}
			onMouseLeave={toogle}
		>
			<button
				className="btn btn-empty language-button dropdown-toggle"
				data-bs-toggle="dropdown"
				aria-haspopup="true"
				aria-expanded="false"
			>
				{currentLanguage.svg}
				{currentLanguage.name}
			</button>
			<div
				className="dropdown-menu"
				style={{
					display: display ? 'block' : 'none'
				}}
			>
				{languages.map((language) => {
					return (
						<span
							key={'lang' + language.code}
							onClick={() => changeLanguage(language.code)}
							className="dropdown-item py-2"
						>
							{language.svg}
							<i
								className={'flag-icon flag-icon-' + (language.code === 'en' ? 'us' : language.code)}
								title={language.code}
								id={language.code}
							></i>
							<span className="ml-1"> {language.name} </span>
						</span>
					);
				})}
			</div>
		</div>
	);
}

export default Languages;
